import * as diff from 'diff'
import './_Diff.scss'
import { useMemo } from 'react'

type DiffProps = {
	oldStr: string
	newStr: string
}

const Diff = ({ oldStr, newStr }: DiffProps) => {
	let groups: diff.Change[] = []

	groups = useMemo(() => {
		try {
			return diff.diffWords(oldStr, newStr)
		} catch (e) {
			return []
		}
	}, [oldStr, newStr])

	const mappedNodes = groups.map((group: diff.Change, index: number) => {
		const { value, added, removed } = group
		return (
			<span key={value + index} className={added ? 'added' : removed ? 'removed' : ''}>
				{value}
			</span>
		)
	})

	return <span>{mappedNodes}</span>
}

export default Diff
